module.exports = __webpack_public_path__ + "static/img/btn_chat_info.bbe6d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_chat_info.png
// module id = Q+ki
// module chunks = 1